module.exports = __webpack_public_path__ + "img/control-utilization-example@2x.7ec06ae7.png";